export type AdTag = {
  type: string;
  url: string;
};

export type AdBreak = {
  id: string;
  position: string;
  tag: AdTag;
};

export type Profile = {
  id: string;
  name: string;
  adBreaks: AdBreak[];
};

export type PlayerProfileResponse = {
  data: Profile[];
};

const isValidAdTag = (data: unknown): data is AdTag => {
  if (typeof data === 'object' && data !== null) {
    const adTag = data as AdTag;
    return typeof adTag.type === 'string' && typeof adTag.url === 'string';
  }
  return false;
};

const isValidAdBreak = (data: unknown): data is AdBreak => {
  if (typeof data === 'object' && data !== null) {
    const adBreak = data as AdBreak;
    return (
      typeof adBreak.id === 'string' &&
      typeof adBreak.position === 'string' &&
      isValidAdTag(adBreak.tag)
    );
  }
  return false;
};

const isValidProfile = (data: unknown): data is Profile => {
  if (typeof data === 'object' && data !== null) {
    const profile = data as Profile;
    return (
      typeof profile.id === 'string' &&
      typeof profile.name === 'string' &&
      Array.isArray(profile.adBreaks) &&
      profile.adBreaks.every(isValidAdBreak)
    );
  }
  return false;
};

export const isPlayerProfileResponse = (
  data: unknown,
): data is PlayerProfileResponse => {
  if (
    typeof data === 'object' &&
    data !== null &&
    Array.isArray((data as PlayerProfileResponse).data)
  ) {
    return (data as PlayerProfileResponse).data.every(isValidProfile);
  }
  return false;
};
